export default {
    data() {
        return {
            screenWakeLock: null
        }
    },

    async mounted() {
        await this.requestWakeLock();
    },

    async beforeUnmount() {
        await this.releaseWakeLock();
    },

    methods: {
        async requestWakeLock() {
            if ('wakeLock' in navigator) {
                try {
                    this.screenWakeLock = await navigator.wakeLock.request('screen');
                } catch (err) {
                    console.error(`${err.name}, ${err.message}`);
                }
            }
        },

        async releaseWakeLock() {
            if (!this.screenWakeLock) {
                return;
            }
            try {
                await this.screenWakeLock.release();
                this.screenWakeLock = null;
            } catch (err) {
                console.error(`${err.name}, ${err.message}`);
            }
        }
    }
}

